import { z } from 'zod';

import { PdfOrientationType, type IdSalesUnitDto } from '@/services/ws-companies/src/main/resources/rest-api';

export enum PDFStylesFormSearchKey {
  SALES_UNIT_ID = 'salesUnitId',
  ORIENTATION_TYPE = 'orientationType',
}

export const PDFStylesFormSearchParams = z.object({
  [PDFStylesFormSearchKey.SALES_UNIT_ID]: z.custom<IdSalesUnitDto>().optional(),
  [PDFStylesFormSearchKey.ORIENTATION_TYPE]: z.nativeEnum(PdfOrientationType).optional(),
});
export type PDFStylesFormSearchParams = z.infer<typeof PDFStylesFormSearchParams>;
